/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const t = {
  xsmall: "k-fs-xs",
  small: "k-fs-sm",
  medium: "k-fs-md",
  large: "k-fs-lg",
  xlarge: "k-fs-xl"
}, r = {
  light: "k-font-weight-light",
  normal: "k-font-weight-normal",
  bold: "k-font-weight-bold"
}, e = {
  xsmall: "k-m-xs",
  small: "k-m-sm",
  medium: "k-m-md",
  large: "k-m-lg",
  xlarge: "k-m-xl",
  thin: "k-m-thin",
  hair: "k-m-hair"
}, l = {
  xsmall: "xs",
  small: "sm",
  medium: "md",
  large: "lg",
  xlarge: "xl",
  thin: "thin",
  hair: "hair"
}, o = {
  top: "k-mt-",
  right: "k-mr-",
  bottom: "k-mb-",
  left: "k-ml-"
}, i = {
  left: "k-text-left",
  right: "k-text-right",
  center: "k-text-center",
  justify: "k-text-justify"
}, s = {
  lowercase: "k-text-lowercase",
  uppercase: "k-text-uppercase",
  capitalize: "k-text-capitalize"
}, k = {
  inherit: "k-color-inherit",
  primary: "k-color-primary",
  secondary: "k-color-secondary",
  tertiary: "k-color-tertiary",
  info: "k-color-info",
  success: "k-color-success",
  warning: "k-color-warning",
  error: "k-color-error",
  dark: "k-color-dark",
  light: "k-color-light",
  inverse: "k-color-inverse"
};
export {
  t as FONT_SIZE_CLASSES,
  r as FONT_WEIGHT_CLASSES,
  e as MARGIN_ENUM_CLASSES,
  l as MARGIN_ENUM_VALUES,
  o as MARGIN_SIDES_CLASSES,
  i as TEXT_ALIGN_CLASSES,
  s as TEXT_TRANSFORM_CLASSES,
  k as THEME_COLOR_CLASSES
};
